module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<input class="file-transfer-input form-control" style="display: none;" type="file" name="fichier" id="file" accept=".jpg"></input>\r\n<div class="fileTransfer form-control" style="cursor: pointer;" tabindex="0">\r\n    <span class="noFileSelectedText placeholder">'+
((__t=(i18n.t("common:uploadfile.selectFile")))==null?'':__t)+
'</span>\r\n</div>\r\n<div class="phx-field-error mimeType-error ui-state-error d-none">Saisie incorrecte !</div>\r\n<span class="add ui-icon ui-icon-plus"></span>\r\n<span class="remove ui-icon ui-icon-minus"></span>';
}
return __p;
};
